import { breakpoints, measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

type WrapperProps = {
	children: React.ReactNode;
};

const styles = stylex.create({
	header: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		blockSize: {
			default: "56px",
			[breakpoints.md]: "72px",
		},
		flexShrink: 0,
		paddingInline: measure.spacingHorizontalDefault,
		paddingBlock: {
			default: measure.sizeMin,
			[breakpoints.md]: measure.sizeS,
		},
	},
	container: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		inlineSize: "100%",
		maxInlineSize: "960px",
		marginInline: "auto",
	},
});

export const Wrapper = ({ children }: WrapperProps) => {
	return (
		<header {...stylex.props(styles.header)}>
			<div {...stylex.props(styles.container)}>{children}</div>
		</header>
	);
};
